import { useFormik } from "formik";
import React from "react";

import { Button, Card, Form } from "react-bootstrap";
import { setVibhagMessage } from "redux/actions";


import { useAppDispatch } from "redux/store";
import { addVibhag, updateVibhag } from "services/vibhagService";
import { Constant } from "template/Constant";
import * as yup from 'yup';
type Props = {
    row?: any,
    hideShowForm: (actionName) => void;
    getData: (page, pageSize, searchKey) => void;
    action?: string
};
export const VibhagForm: React.FC<Props> = ({ row, hideShowForm, getData, action }) => {
    const dispatch = useAppDispatch();
    const iValue={vibhag_id:0,vibhag_name:'',seq_no:0,is_active:''};
    const initialValue = action === 'edit' ? row : iValue;
    
    
    const formik = useFormik({
        initialValues: initialValue,
        onSubmit: async (values) => {
            if (action === 'edit') {
                const response = await updateVibhag(row.vibhag_id,values);
               if (response && (response.status === 200 || response.status === 201)) {
                    dispatch(setVibhagMessage("Updated Successfully"));
                    getData(Constant.defaultPageNumber, Constant.defaultPageSize, '');
                    hideShowForm('');
                } else {
                    dispatch(setVibhagMessage("Some error occured!"));
                }
            } else if (action === 'add') {
                const response = await addVibhag(values);
               if (response && (response.status === 200 || response.status === 201)) {
                    dispatch(setVibhagMessage("Added Successfully"));
                    getData(Constant.defaultPageNumber, Constant.defaultPageSize, '');
                    hideShowForm('');
                } else {
                    dispatch(setVibhagMessage("Some error occured!"));
                }
            }
        },
        validationSchema: yup.object({
           vibhag_name: yup.string().required('vibhag_name is required'),
seq_no: yup.number().required('seq_no is required'),
is_active: yup.boolean().required('is_active is required'),

        }),
    });
    return (
        <Card className="shadow mb-4">
            <Card.Header className="py-3">
                <h6 className="m-0 font-weight-bold text-primary text-capitalize">{action} Vibhag
                    <Button className="btn-icon-split float-right" onClick={() => hideShowForm(false)}>
                        <span className="icon text-white-50">
                            <i className="fas fa-list"></i>
                        </span>
                        <span className="text">View Vibhag</span>
                    </Button>
                </h6>

            </Card.Header>
            <Card.Body>
                <Form onSubmit={formik.handleSubmit}>
                  <Form.Group>
<label className="form -control-label">vibhag_name</label>
<Form.Control type="text" name="vibhag_name" className="form-control" value={formik.values.vibhag_name}
onChange={formik.handleChange}
onBlur ={formik.handleBlur}
isInvalid ={!!formik.touched.vibhag_name && !!formik.errors.vibhag_name}
isValid ={!!formik.touched.vibhag_name && !formik.errors.vibhag_name}
></Form.Control>
{
    formik.errors.vibhag_name && (
    <Form.Control.Feedback type="invalid">
        <>{formik.errors.vibhag_name}</>
    </Form.Control.Feedback>
)}
</Form.Group>
<Form.Group>
<label className="form -control-label">seq_no</label>
<Form.Control type="number" name="seq_no" className="form-control" value={formik.values.seq_no}
onChange={formik.handleChange}
onBlur ={formik.handleBlur}
isInvalid ={!!formik.touched.seq_no && !!formik.errors.seq_no}
isValid ={!!formik.touched.seq_no && !formik.errors.seq_no}
></Form.Control>
{
    formik.errors.seq_no && (
    <Form.Control.Feedback type="invalid">
        <>{formik.errors.seq_no}</>
    </Form.Control.Feedback>
)}
</Form.Group>
<Form.Group>
<label className="form -control-label">is_active</label>
<Form.Control type="number" name="is_active" className="form-control" value={formik.values.is_active}
onChange={formik.handleChange}
onBlur ={formik.handleBlur}
isInvalid ={!!formik.touched.is_active && !!formik.errors.is_active}
isValid ={!!formik.touched.is_active && !formik.errors.is_active}
></Form.Control>
{
    formik.errors.is_active && (
    <Form.Control.Feedback type="invalid">
        <>{formik.errors.is_active}</>
    </Form.Control.Feedback>
)}
</Form.Group>

                    <Form.Group>
                        <Button type="submit" className="float-right" variant="primary">Save</Button>
                    </Form.Group>
                </Form>
            </Card.Body>
        </Card>
    );
}

